import apiClient from "../apiClient";

export const sendEmailForgotPassword = async (email) => {
  try {
    const response = await apiClient.post("users/forgot-password", email);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async ({ userData, token }) => {
  try {
    console.log("Token de reset contraseña", token);
    const response = await apiClient.post(
      `users/reset-password/${token}`,
      userData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
